import type { IntlShape } from "@formatjs/intl";
import { Flex } from "antd";
import { connect, type DispatchProp } from "react-redux";
import { actions } from "redux-router5";
import { ResourceErrorResult } from "../common/components/ResourceErrorResult";
import ConnectedAppLayout from "./AppLayout";
import { routeNames } from "./common/routes";
import type { RootState } from "./store";
import styles from "./PageErrorPage.module.css";

type PageErrorPageProps = {
	status: number;
	intl: IntlShape;
	hasRoute: boolean;
};

const PageErrorPage = (props: PageErrorPageProps & DispatchProp) => {
	const { status, intl, hasRoute, dispatch } = props;
	const result = (
		<ResourceErrorResult
			status={status}
			intl={intl}
			onGoToDashboard={() => dispatch(actions.navigateTo(routeNames.DASHBOARD))}
			onGoBack={() => window.history.back()}
		/>
	);
	// AppLayout renders nothing without an active route (unknown URL), so show the result on its own
	if (!hasRoute) {
		return (
			<Flex
				vertical
				className={styles.standaloneWrapper}
				align="center"
				justify="center"
			>
				{result}
			</Flex>
		);
	}
	return <ConnectedAppLayout>{result}</ConnectedAppLayout>;
};

export const ConnectedPageErrorPage = connect((state: RootState) => ({
	intl: state.intl.datetimeIntl,
	hasRoute: state.router.route !== null,
}))(PageErrorPage);

export default ConnectedPageErrorPage;
